import React from "react";
import { LegalLayout, H2, P, UL } from "./LegalLayout";

export default function RefundPolicyPage() {
  return (
    <LegalLayout testid="refund-page" title="Refund Policy" lastUpdated="February 1, 2026">
      <P>
        At Simple Style Mode we want you to love every piece. If something isn't quite right,
        our refund policy sets out your rights and how to return a Product. This policy applies
        to purchases made on simplestylemode.com and operated by{" "}
        <strong>ULTRANEQ LLC</strong>, registered at 2105 Vista Oeste NW, Albuquerque, NM 87120, United States.
      </P>

      <H2>1. Return window</H2>
      <P>
        You have <strong>30 calendar days</strong> from the date of delivery to request a
        return. Return requests submitted after this period cannot be accepted.
      </P>

      <H2>2. Return conditions</H2>
      <P>To be eligible for a refund, Products must be:</P>
      <UL>
        <li>Unworn, unwashed and undamaged</li>
        <li>In their original condition with all tags attached</li>
        <li>Returned in the original packaging where possible</li>
        <li>Accompanied by the order number or proof of purchase</li>
      </UL>
      <P>
        For hygiene reasons, items such as underwear, swimwear and pierced jewellery cannot be
        returned unless they arrived defective or incorrect.
      </P>

      <H2>3. How to initiate a return</H2>
      <UL>
        <li>Email <a href="mailto:support@simplestylemode.com" className="underline">support@simplestylemode.com</a> with your order number and the item(s) you wish to return.</li>
        <li>We will reply within 1 business day with a prepaid return label (for US orders) or return instructions (international orders).</li>
        <li>Pack the item securely and attach the return label.</li>
        <li>Drop off the parcel at the indicated carrier.</li>
      </UL>

      <H2>4. Return shipping costs</H2>
      <UL>
        <li><strong>United States:</strong> Returns are free. We provide a prepaid label.</li>
        <li><strong>International:</strong> Return shipping is paid by the Customer, except for defective or incorrect items, in which case we cover the cost.</li>
      </UL>

      <H2>5. Refund processing times</H2>
      <UL>
        <li>We inspect the returned items within 2 business days of receipt.</li>
        <li>Once approved, refunds are issued to the original payment method.</li>
        <li>Refunds typically appear on your statement within <strong>5–10 business days</strong>, depending on your bank or card issuer.</li>
        <li>Shipping fees are non-refundable except where the return is due to our error or a defective Product.</li>
      </UL>

      <H2>6. Exchanges</H2>
      <P>
        We currently offer exchanges on size only, subject to stock availability. To exchange a
        size, please email us at support@simplestylemode.com. If the requested size is
        unavailable, we will process a standard refund.
      </P>

      <H2>7. Defective or incorrect items</H2>
      <P>
        If you receive a Product that is defective, damaged during shipping, or not what you
        ordered, please contact us within 7 days of delivery with photos. We will arrange a
        free return and send a replacement or issue a full refund, including original shipping
        costs, at your choice.
      </P>

      <H2>8. Order cancellations</H2>
      <P>
        You may cancel an order free of charge at any time before it has been dispatched. Once
        dispatched, the standard return procedure applies.
      </P>

      <H2>9. Your statutory rights</H2>
      <P>
        This policy does not affect your legal rights under applicable consumer protection
        laws. In particular, if you are a consumer resident in the European Union or the
        United Kingdom, you benefit from a statutory 14-day withdrawal right in addition to the
        30-day return window described above. You may exercise this right by sending a clear
        statement to support@simplestylemode.com. Returned goods must still meet the condition
        requirements set out in Section 2.
      </P>

      <H2>10. Contact</H2>
      <P>
        For any return-related question, please reach out to us at{" "}
        <a href="mailto:support@simplestylemode.com" className="underline">support@simplestylemode.com</a>{" "}
        — we aim to reply within one business day.
      </P>
    </LegalLayout>
  );
}
